declare var require: any;
const blobUtil = require('blob-util');

export const fileToBlob = file => {
    const dataUrl = file.content;
    return blobUtil.dataURLToBlob(dataUrl);
};